module.exports = __webpack_public_path__ + "img/footer-5g.552d6a7e.png";